import React from 'react';
export default class CustomMarker extends React.Component {
  render() {
    return (
      <svg
        width="20px"
        height="20px"
        viewBox="0 0 42 42"
        className="donut"
        aria-labelledby="beers-title beers-desc"
        role="img"
      >
        <circle
          className="donut-hole"
          cx="21"
          cy="21"
          r="15.91549430918954"
          fill="white"
          role="presentation"
        ></circle>
        <circle
          className="donut-ring"
          cx="21"
          cy="21"
          r="15.91549430918954"
          fill="transparent"
          stroke="#d2d3d4"
          strokeWidth="3"
          role="presentation"
        ></circle>
        <circle
          className="donut-segment"
          cx="21"
          cy="21"
          r="15.91549430918954"
          fill="transparent"
          stroke={this.props.border}
          strokeWidth="3"
          strokeDasharray={`${100} ${100}`}
          strokeDashoffset="0"
          aria-labelledby="donut-segment-1-title donut-segment-1-desc"
        ></circle>
        <g className="chart-text">
          <text className="chart-number" x={this.props.count < 10 ? '40%' : '35%'} y="60%">
            {this.props.count}
          </text>
        </g>
      </svg>
    );
  }
}
